import React from 'react';

const Pay = () => {
    return (
        <div>
            <h1>Payment Coming Soon</h1>
        </div>
    );
};

export default Pay;